import { CommonParams } from '@/api/resources/common/shared/models/common.models'
import { configurationCenterServices } from '@/api/resources/configuration/centersAndAreas/center/configuration-center-services'
import { ConfigurationPetitionerResponse } from '@/modules/configurationModule/detail/automation/notifications/automation-notifications-case/services/configuration-petitioner/configuration-petitioner.dto'
import { configurationPetitionerService } from '@/modules/configurationModule/detail/automation/notifications/automation-notifications-case/services/configuration-petitioner/configuration-petitioner.service'
import { ConfigurationInsurerResponse } from '@/modules/configurationModule/detail/cases/insurers/services/configuration-insurer.dto'
import { configurationInsurerService } from '@/modules/configurationModule/detail/cases/insurers/services/configuration-insurer.service'
import { ConfigurationLocalAccountingBillableClientsModalRulesItem } from '@/modules/configurationModule/detail/local-accounting/billable/clients/components/clients-modal-rules/configuration-local-accounting-billable-clients-modal-rules.model'
import { ConfigurationCenterResponse } from '@/modules/configurationModule/shared/services/configuration.dto'
import { IResponseAgGrid } from '@/shared/models/ag-grid.model'
import { PAGINATOR_BIG_PAGE_SIZE } from '@/shared/services/services-constants'
import { StrictNullable } from '@/shared/types/app.types'
import { PromiseUtils } from '@/shared/util/promise-utils'

const collectionParams: CommonParams = {
    size: PAGINATOR_BIG_PAGE_SIZE
}

const collectionFilterModel = {
    'active': {
        filterType: 'boolean',
        type: 'equals',
        filter: true
    }
}

export const configurationLocalAccountingBillableClientsHelpersGetCenters = async (): Promise<ConfigurationLocalAccountingBillableClientsModalRulesItem[]> => {
    const response: StrictNullable<IResponseAgGrid<ConfigurationCenterResponse>> = await PromiseUtils.toCallSecure(
        configurationCenterServices.paginator(collectionFilterModel, collectionParams)
    )
    return response?.content.map((item: ConfigurationCenterResponse) => {
        return {
            id: item.id,
            text: item.name
        }
    }) || []
}

export const configurationLocalAccountingBillableClientsHelpersGetInsurers = async (): Promise<ConfigurationLocalAccountingBillableClientsModalRulesItem[]> => {
    const response: StrictNullable<IResponseAgGrid<ConfigurationInsurerResponse>> = await PromiseUtils.toCallSecure(
        configurationInsurerService.paginator(collectionFilterModel, collectionParams)
    )
    return response?.content.map((item: ConfigurationInsurerResponse) => {
        return {
            id: item.id,
            text: item.name
        }
    }) || []
}

export const configurationLocalAccountingBillableClientsHelpersGetPetitioners = async (): Promise<ConfigurationLocalAccountingBillableClientsModalRulesItem[]> => {
    const response: StrictNullable<IResponseAgGrid<ConfigurationPetitionerResponse>> = await PromiseUtils.toCallSecure(
        configurationPetitionerService.paginator(collectionFilterModel, collectionParams)
    )
    return response?.content.map((item: ConfigurationPetitionerResponse) => {
        return {
            id: item.id,
            text: item.fullName
        }
    }) || []
}
